import { ISetDescriptionParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetDatasourceDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setDatasourceDescription', {
      id: id,
      description: description
    });
  }
}
